import React from "react";
import self from "../img/self.png";

export let colors = ["rgb(1, 208, 108)", "rgb(5, 186, 199)"];

/**
 * Generates and returns a font awesome
 * icon for the name provided
 * @param {string} name
 * @param {string} [mainClass] the main icon class (fab, fas, fa...)
 */
export const fetchIcon = (name, mainClass = 'fab') => {
  return <i className={`${mainClass} fa-${name}`} aria-hidden="true" />
};

export const info = {
  firstName: "Watch",
  lastName: "Rentals",
  initials: "WR",
  positions: ["Kamran Farid", "Timepiece Pretender", "Luxury Faker", "Fake Flexer"],
selfPortrait: self,
gradient: `linear-gradient(135deg, ${colors})`,
miniBio: [
  ["💼", "Private Rentals @ WatchRentals"],
  ["⌚", "Certified Watch Leaser"],
  ["🧢", "Based wherever the cap is"],
  ["✉️", "capper69@424424242.com"],
],
socials: [
  ["https://www.linkedin.com/in/kamranfarid", fetchIcon('linkedin', 'fa')],
  ["https://instagram.com/narmak007", fetchIcon('instagram')],
],
bio:
  "Hello! I'm not rich, but I play one online. I lease luxury watches and pretend to be a millionaire. I love to flex my fake lifestyle on social media, and I'm always looking for new ways to show off my 'wealth'. If you're looking for someone to help you fake it till you make it, I'm your guy!",
  // "I'm a professional watch borrower, and I love to flex my fake lifestyle on social media. I also enjoy reading fake invoices and parking rentals in valet-only zones. If you're looking for someone to help you fake it till you make it, I'm your guy!",
hobbies: [
  ["🛖", "pretending to lease Rolexes"],
  ["📖", "reading fake invoices"],
  ["🏎️", "parking rentals in valet-only zones"],
  ["✍", "signing fake contracts"],
  ["🧑‍💻", "hacking your expectations"],
]

  ,
  portfolio: [
    {
      title: "Audemars Piguet 2022 Double Balance Wheel Open worked Stainless Steel",
      liveLink: "#",
      sourceLink: "https://www.github.com/webnovare/",
    },
    {
      title: "Audemars Piguet 2022 Double Balance Wheel Open worked Stainless Steel",
      liveLink: "#",
      sourceLink: "https://www.github.com/webnovare/",
    },
    {
      title: "Audemars Piguet 2022 Double Balance Wheel Open worked Stainless Steel",
      liveLink: "#",
      sourceLink: "#",
    },
    {
      title: "Audemars Piguet 2022 Double Balance Wheel Open worked Stainless Steel",
      liveLink: "#",
      sourceLink: "https://www.github.com/webnovare/",
    },
  ],
};
